module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-flexbox",
    class: {
      'mu-flex-col': _vm.orient === 'vertical',
      'mu-flex-row': _vm.orient === 'horizontal'
    },
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e329094e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/flexbox/flexbox.vue
// module id = 3856
// module chunks = 1